(function() {

	var container = '.js-container';
	var $container = $(container);

	var params = {
		dataBreakpoint: 'breakpoint',
		dataContent: 'content'
	};

	//	======================================================================  //
	//	Functions
	//	======================================================================  //

	/**
	 * @function `transfer`
	 *
	 * Interchanges the content between the containers depending of the width of
	 * the viewport.
	 */
	function transfer() {

		var $origin = $($container.data(params.dataContent));

		if( _window_width > _breakpoints[$container.data(params.dataBreakpoint)] ) {
			if( $container.html() === '' ) {
				$container.html( $origin.html() );
				$origin.html( '' );
			}
		} else {
			if( $origin.html() === '' ) {
				$origin.html( $container.html() );
				$container.html('');
			}
		}
	}

	//	======================================================================  //
	//	On ready
	//	======================================================================  //

	onReady.callbacks.transfer = function() {
		transfer();
	};

	//	======================================================================  //
	//	On resize
	//	======================================================================  //

	onResize.callbacks.transfer = function() {
		transfer();
	};

})();
